<template><!-- svgo-optimised -->
<svg class="icon icon__check" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m13.569 4.471-7.57 7.57-3.568-3.57L2.902 8 6 11.098 13.097 4l.472.471Z" fill="#fff" fill-rule="evenodd" clip-rule="evenodd"/></svg>
</template>